import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Address } from 'src/app/shared/models/address.model';
import { Practitioner } from 'src/app/shared/models/practitioner.model';

@Component({
  selector: 'app-practitioner-edit-business',
  templateUrl: './practitioner-edit-business.component.html',
  styleUrls: ['./practitioner-edit-business.component.scss']
})
export class PractitionerEditBusinessComponent implements OnInit {
  healthCategories = ['Mental well-being', 'Physical well-being', 'Both'];
  formGroup: FormGroup;
  address: Address;
  @Input() isLoading: boolean;
  @Input() practitioner: Practitioner;
  @Output() dismissed = new EventEmitter<void>();
  @Output() submitted = new EventEmitter<FormGroup>();

  constructor() { }

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      'organization': new FormControl(this.practitioner?.location?.organization),
      'offersVirtual': new FormControl(this.practitioner?.offersVirtual, Validators.required),
      'healthCategory': new FormControl(this.practitioner?.healthCategory?.length > 1 ? 'Both' : this.practitioner.healthCategory[0], Validators.required)
    });

    this.address = this.practitioner?.location;
  }

  onSubmit(): void {
    if (!this.formGroup.valid) { return; }
    this.address.organization = this.formGroup.get('organization').value;
    let finalFormGroup = new FormGroup({
      'offersVirtual': new FormControl(this.formGroup.get('offersVirtual').value),
      'healthCategory': new FormControl(this._mapHealthCategory()),
      'location': new FormControl(this.address)
    });

    if (this.formGroup.get('offersVirtual').dirty) {
      finalFormGroup.get('offersVirtual').markAsDirty();
    }
    if (this.formGroup.get('healthCategory').dirty) {
      finalFormGroup.get('healthCategory').markAsDirty();
    }
    if (this.address.getFullAddress() !== this.practitioner.location.getFullAddress() || this.formGroup.get('organization').dirty) {
      finalFormGroup.get('location').markAsDirty();
    }

    this.submitted.emit(finalFormGroup);
  }

  _mapHealthCategory(): string[] {
    var categories: string[] = [];
    var value: string = this.formGroup.get('healthCategory').value;

    if (value.toLowerCase().indexOf('both') === -1) {
      categories.push(value)
    } else {
      categories.push('Physical well-being');
      categories.push('Mental well-being');
    }

    return categories;
  }

  getAddress(place: google.maps.places.PlaceResult) {
    this.address = Address.createAddressFromPlace(place);
  }


  onDismiss(): void {
    this.dismissed.emit();
  }
}
